import { FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { inputStateUpdate } from "../utility";
import { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import useFormStyles from "../../../styles/useFormStyles";

export type RadioInputSectionProps = {
  label?: string;
  stateKey: string;
  setState: Function;
  defaultValue: boolean | string;
  clear?: boolean;
  options: string[];
  onChange?: (selectedOption: string) => void;
};

const RadioInputSection: React.FC<RadioInputSectionProps> = (
  props: RadioInputSectionProps
) => {
  const { label, stateKey, setState, defaultValue, clear } = props;
  const [radioState, setRadioState] = useState<boolean | string>(defaultValue);
  const formStyles = useFormStyles();
  const theme = useTheme();

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setRadioState((prevValue) => {
      if (typeof prevValue === "boolean") {
        return newValue === "true";
      } else {
        return newValue;
      }
    });
    if (props.onChange) {
      props.onChange(newValue);
    }
  };

  useEffect(() => {
    if (clear) {
      setRadioState(defaultValue);
    } else {
      inputStateUpdate(stateKey, setState, radioState);
    }
  }, [radioState, clear]);

  return (
    <>
      {label ? (
        <FormLabel sx={{ ...formStyles.formLabel, color: "#252836" }}>{label} </FormLabel>
      ) : null}
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        value={
          typeof radioState === "boolean" ? radioState.toString() : radioState
        }
        name="radio-buttons-group"
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
        onChange={changeHandler}
      >
        {props.options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={
              <Radio
                sx={{
                  color: theme?.color?.secondary,
                  "&.Mui-checked": {
                    color: theme?.color?.secondary,
                  },
                }}
              />
            }
            label={option}
          />
        ))}
      </RadioGroup>
    </>
  );
};

export default RadioInputSection;
